<template>
  <div class="h-2 w-full rounded-full relative bg-gray-300 dark:bg-dark-100">
    <div
      :class="`progress-bar-color h-full rounded-full absolute top-0 left-0 ${
        colorType === 'COURSE' ? 'bg-course dark:bg-course-dark' : 'bg-challenge'
      }`"
      :style="`--bar-width: ${num};`"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    num: {
      type: Number,
      default: 0
    },
    colorType: {
      type: String,
      default: 'COURSE'
    }
  },
  setup() {}
})
</script>

<style scoped>
.progress-bar-color {
  animation-name: bar;
  animation-duration: 800ms;
  animation-delay: 100ms;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes bar {
  from {
    width: 0;
  }

  to {
    width: calc(100% * (var(--bar-width) / 100));
  }
}
</style>
